<template>
  <header
    class="flex flex-col gap-6 max-w-[636px]"
    :class="[headerAlignmentClass]"
  >
    <p v-if="sectionStrapline" class="text-subheading">
      {{ sectionStrapline }}
    </p>

    <h2 v-if="sectionHeading" class="text-h2">
      {{ sectionHeading }}
    </h2>

    <DrupalMarkup
      v-if="sectionCopy"
      :content="sectionCopy"
      class="text-body-small mt-4"
    />

    <div v-if="hasPrimaryCta" class="flex flex-row gap-4" :class="justifyClass">
      <slot name="primaryCta" />
    </div>
  </header>
</template>

<script setup lang="ts">
const { isRtl } = useAppLocale();
const slots = useSlots();

const {
  sectionCopy,
  sectionHeading,
  sectionStrapline,
  textAlign = 'left',
} = defineProps<{
  sectionCopy?: string | string[];
  sectionHeading?: string;
  sectionStrapline?: string;
  textAlign?: 'left' | 'center' | 'right';
}>();

defineSlots<{
  primaryCta?(): unknown;
}>();

const hasPrimaryCta = computed(() => Boolean(slots.primaryCta?.().length));

const resolvedTextAlign = computed<'left' | 'center' | 'right'>(() => {
  if (textAlign === 'center') return 'center';
  if (!isRtl.value) return textAlign;

  return textAlign === 'left' ? 'right' : 'left';
});

const headerAlignmentClass = computed(() => {
  switch (resolvedTextAlign.value) {
    case 'center':
      return 'text-center mx-auto';
    case 'right':
      return 'text-right';
    default:
      return 'text-left';
  }
});

const justifyClass = computed(() => {
  switch (resolvedTextAlign.value) {
    case 'center':
      return 'justify-center';
    case 'right':
      return 'justify-end';
    default:
      return 'justify-start';
  }
});
</script>
